define('plugin/classes/view/datetime/TimeClassesPluginView',['require','view/controller/booking/datetime/TimeDefaultView','plugin/classes/view/datetime/TimeClassesPluginColumnView','Config'],function (require) {

    var TimeDefaultView = require('view/controller/booking/datetime/TimeDefaultView');
    var TimeClassesPluginColumnView = require('plugin/classes/view/datetime/TimeClassesPluginColumnView');
    var Config = require('Config');

    /**
     * Flexible timeline view (container)
     *
     * @class TimeClassesPluginView
     */
    return TimeDefaultView.extend({

        template: '#time_classes_plugin_view',
        childView: TimeClassesPluginColumnView,
        childViewContainer: '#sb_time_classes_plugin_container',
        childViewOptions: function (model) {
            return {
                'collection': model.get('slots'),
                'providerModel': this._providerCollection.get(model.get('provider_id')),
                'serviceModel': this._serviceCollection.get(model.get('service_id')),
                'slotsCount': this._totalSlots,
                'clientTimeZone': this.getOption('clientTimeZone'),
                'timeFrom': this._timeFrom,
                'timeTo': this._timeTo,
                'timeFrame': this._timeFrame,
                'waitingListHelperModel': this.getOption('waitingListHelperModel'),
            };
        },
        _timeFrom: new Time(),
        _timeTo: new Time(),
        _totalSlots: 0,
        _timeFrame: 5,
        _timeCollection: null,
        _classesCollection: null,
        _providerCollection: null,
        _serviceCollection: null,
        _clientTimezoneModel: null,
        _bookingModel: null,

        initialize: function () {
            this._classesCollection = this.getOption('classesCollection');
            this._providerCollection = this.getOption('providerCollection');
            this._serviceCollection = this.getOption('serviceCollection');
            this._clientTimezoneModel = this.getOption('clientTimeZone');
            this._bookingModel = this.getOption('bookingModel');

            this.listenTo(this._classesCollection, 'sync', this.updateTimeLine);
            this.listenTo(this._providerCollection, 'sync', this.updateTimeLine);
            this.listenTo(this._serviceCollection, 'sync', this.updateTimeLine);
            // this.listenTo(this._serviceCollection, 'reset', this.updateTimeLine); //TODO remove - this is not required for 8344 fix
            this.listenTo(this._clientTimezoneModel, 'sync', this.updateTimeLine);

            TimeDefaultView.prototype.initialize.apply(this);

            if (this._classesCollection.length) {
                this.updateTimeLine();
            }
        },

        updateTimeLine: function () {
            var instance = this;

            if (!this._serviceCollection.length) {
                return;
            }

            this.collection = this._classesCollection;

            if (!this._clientTimezoneModel.isReady()) {
                return;
            }

            this._timeCollection = this._classesCollection.getTimeCollection(this._clientTimezoneModel.get('time_diff'));

            var from = this._timeCollection.first();
            var to = this._timeCollection.last();

            if (from && to) {
                this._timeFrom = new Time(from.get('time'));
                this._timeTo = new Time(to.get('time'));

                this._timeFrame = Config.getInstance().getTimeFrame();
            }

            instance._expandRows = false;

            this.collection.each(function(model) {
                if (model.get('slots')) {
                    model.get('slots').each(function (slot) {
                        if (slot.get('slots_count') === 1) {
                            instance._expandRows = true;
                        }
                    });
                }
            });


            this._totalSlots = this._timeCollection.length;
            this.render();
        },

        filter: function (model) {
            var serviceId = model.get('service_id');
            if(serviceId && this._serviceCollection.length){
                var serviceModel = this._serviceCollection.get(serviceId);
                if(!serviceModel){
                    return false;///service filtered, maybe by group booking;
                }
            }
            if(Config.getInstance().getPluginStatus('waiting_list')){
                return this._clientTimezoneModel.isReady();
            } else {
                return model.get('slots').length !== 0 && this._clientTimezoneModel.isReady();
            }
        },

        _getServicesJSON: function () {
            var services = this._serviceCollection.toJSON();
            return services;
        },

        serializeData: function () {
            var result = TimeDefaultView.prototype.serializeData.apply(this);

            result.is_empty = true;
            if (this._timeCollection && this._clientTimezoneModel.isReady()) {
                result.available_time = this._timeCollection.toJSON();
                result.is_empty = !result.available_time.length;
            }
            var waitingListHelperModel = this.getOption('waitingListHelperModel');
            if(waitingListHelperModel) {
                result.is_available_date = waitingListHelperModel.isTodayOrFutureDates() && waitingListHelperModel.isWorkDateInterval();
            }

            if(Config.getInstance().getPluginStatus('waiting_list')){
                if(this.collection && this.collection.length) {
                    result.wl_available_services = [];
                    this.collection.each(function (model) {
                        result.wl_available_services[model.get('service_id')] = model.get('is_wl_available');
                    });
                }
            }

            result.services = this._getServicesJSON();
            result.expandRows = this._expandRows;
            return result;
        }

    });

});
